/* eslint-disable import/no-cycle */
import { connect } from 'react-redux';
/* Actions */
import { toggleModal } from '../../redux/actions/modalActions';
/* Component */
import Tickets from './Tickets';

const mapStateToProps = state => ({
  authUser: state.authUser,
  balance: state.balance,
  cart: state.cart,
  customer: state.customer,
  discount: state.discount,
  loads: state.loads,
  modals: state.modals,
  tabs: state.tabs,
  timbrar: state.timbrar,
  // cotizacion: state.cotizacion,
});

const mapDispatchToProps = dispatch => ({
  dispatchToggleTicketsModal: () => dispatch(toggleModal('tickets')),
  dispatchToggleTicketsCCModal: () => dispatch(toggleModal('ticketCC')),
  dispatchToggleTicketsFactura: () => dispatch(toggleModal('ticketsFactura')),
});

export default connect(mapStateToProps, mapDispatchToProps)(Tickets);
